module.exports = __webpack_public_path__ + "img/history-today.86ec82eb.png";